import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'; // Import useDispatch and useSelector
import rootSlice from '../redux/authService'; // Import the authService slice
import { selectIsLoggedIn } from '../redux/rootSlice';

const RedirecLoggedOut = (path) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginStatus = useSelector(selectIsLoggedIn); // Now using selectIsLoggedIn

  useEffect(() => {
    const handleLoginStatus = async () => {
      if (!loginStatus) { // Check loginStatus directly
        try {
          await dispatch(rootSlice.actions.loginWithCode({ /* login data */ }));
        } catch (error) {
          console.log(error.message);
        }
      }
    

      if (!loginStatus) {
        toast.info("Session Expired, Please login");
        navigate(path);
      }
    };

    handleLoginStatus();
  }, [path, navigate, dispatch]); 

  return null; 
};

export default RedirecLoggedOut;
